export default "__VITE_ASSET__0c3ZrucO__"